module.exports = __webpack_public_path__ + "static/media/SDFSA_3-960w.60254cd3.webp";